import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
export function getSelectedModifierIds(item) {
  var _item$item_variation_ = item.item_variation_data.modifiers,
    modifiers = _item$item_variation_ === void 0 ? [] : _item$item_variation_;
  return modifiers.map(function (modifier) {
    return modifier.object_id;
  });
}
export function transformVariationsToLegacyFormat() {
  var variations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return variations.map(function (_ref, i) {
    var objectId = _ref.object_id,
      name = _ref.name,
      price = _ref.price;
    return {
      _id: objectId,
      name: name,
      price: price,
      order: i
    };
  });
}
export function transformModifiersToLegacyFormat() {
  var modifiers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return modifiers.map(function (_ref2) {
    var objectId = _ref2.object_id,
      name = _ref2.name,
      price = _ref2.price,
      modifierSetObjectId = _ref2.modifier_list_object_id;
    return {
      _id: objectId,
      description: '',
      // no description in the new format
      name: name,
      price: price,
      modifierSetId: modifierSetObjectId
    };
  });
}
export function transformModifierSetsToLegacyFormat() {
  var modifierSets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return modifierSets.map(function (_ref3) {
    var modifierSetObjectId = _ref3.object_id,
      name = _ref3.name,
      minAllowed = _ref3.default_min_selected_modifiers,
      maxAllowed = _ref3.default_max_selected_modifiers;
    return {
      _id: modifierSetObjectId,
      name: name,
      description: '',
      // no description in the new format
      minAllowed: minAllowed,
      maxAllowed: maxAllowed,
      modifiers: modifiers.filter(function (modifier) {
        return modifier.modifier_list_object_id === modifierSetObjectId;
      }).map(function (_ref4) {
        var modifierObjectId = _ref4.object_id;
        return modifierObjectId;
      })
    };
  });
}
export function updateCartItem(cartItem, catalogItem) {
  var newQuantity = catalogItem.quantity,
    newSpecialInstructions = catalogItem.specialInstructions,
    newVariationId = catalogItem.selectedVariation._id,
    selectedModifiers = catalogItem.selectedModifiers;
  var newModifierIds = selectedModifiers.map(function (_ref5) {
    var modifierId = _ref5._id;
    return modifierId;
  });
  var newItemVariation = {
    object_id: newVariationId,
    modifiers: newModifierIds
  };
  return _objectSpread(_objectSpread({}, cartItem), {}, {
    quantity: newQuantity,
    instructions: newSpecialInstructions,
    item_variation: newItemVariation
  });
}